// Copyright (c) 2021 WiseTime. All rights reserved.

import { CreateUserCueRequest, UserCue } from "../../generated/wisetime/user/cues/v4/user_cues_pb"
import { Timestamp } from "google-protobuf/google/protobuf/timestamp_pb"
import { DateTime } from "luxon"

type TutorialAppCues = { [key: string]: string }

export const tutorialAppCues: TutorialAppCues = {
  FULL: "8c68a4aa-e67e-43a7-abf6-f72ca820f55c",
  FUTURE: "ceee4919-6f16-4cc8-8c0d-f6c6c8e49182",
  EMPTY_DAY: "15596133-4b3d-476e-889c-380a9a4a08c9"
}

const buildAppCue = (shownUserCues: UserCue.AsObject[], cueId: string, appCueId: string): CreateUserCueRequest | undefined => {
  if (shownUserCues.some(cue => cue.id === cueId)) {
    return undefined
  }
  const noTypeWindow = window as any
  if (!noTypeWindow.Appcues) {
    return undefined
  }
  noTypeWindow.Appcues.show(appCueId)
  return new CreateUserCueRequest()
    .setUserCue(
      new UserCue()
        .setId(cueId)
        .setDescription(cueId)
        .setCreateTime(new Timestamp().setSeconds(Math.round(DateTime.local().toSeconds())))
    )
}

export const buildTrashedTimeRowAppcue = (shownUserCues: UserCue.AsObject[]): CreateUserCueRequest | undefined =>
  buildAppCue(shownUserCues, "trashed-time-row", "d467b851-d80c-4ae2-a1b0-4bf5b367a6e8")

export const buildTagRequiredAppcue = (shownUserCues: UserCue.AsObject[]): CreateUserCueRequest | undefined =>
  buildAppCue(shownUserCues, "tag-required-to-post", "08989b6f-3512-417e-aaa7-67cb54a191bf")
